import api, { IUploadedImageAsset } from '@api'

export default function getSpaceAsset(spaceId?: string) {
  return spaceId ? api.space.assets(spaceId) : Promise.resolve([])
}
